//
//
//
//
//
//

var script = {
  name: 'CardText'
};
export { script as default };